import initAccordionSection from '@sectionsJS/accordion';

$(async () => {
  initAccordionSection();
});
